import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { lcvCampaignConstants } from "../../../../_redux/_constants/lcvCampaign.constants";
import { lcvCampaignsGetRequest, lcvCampaignSelect } from "../../../../_redux/_actions/lcvCampaign.action";

// The LCV campaign every LCV admin screen works against. The list is loaded once and kept, so the
// selection survives moving between screens.
export default function useLcvCampaign() {
     const actionDispatch = useDispatch();

     const campaigns = useSelector((state) => state?.lcvCampaign?.campaigns || []);
     const selectedCampaignId = useSelector((state) => state?.lcvCampaign?.selectedCampaignId ?? null);
     const isLoaded = useSelector((state) => state?.lcvCampaign?.isLoaded || false);
     const pendingRequests = useSelector((state) => state?.loading?.pendingRequests || []);

     const isLoading = pendingRequests.includes(lcvCampaignConstants.LCV_CAMPAIGNS_GET_REQUEST);

     useEffect(() => {
          if (!isLoaded) {
               actionDispatch(lcvCampaignsGetRequest({}));
          }
     }, [actionDispatch, isLoaded]);

     const selectCampaign = useCallback(
          (campaignId) => actionDispatch(lcvCampaignSelect(campaignId)),
          [actionDispatch],
     );

     return { campaigns, selectedCampaignId, isLoading, selectCampaign };
}
